module.exports = __webpack_public_path__ + "img/product_78.f25f272.webp";